export const APP_NAME = 'Glitter';
export const APP_DESCRIPTION = 'AI powered ERP to run your luxury goodes business.';
